import type { QuickSearchAction } from "../configuration/QuickSearchActions"
import { appendDateRangeSearchParams } from "./dateRangeSearchParams"

let quickSearchNavigationSequence = 0

export const buildQuickSearchActionSearch = (action: QuickSearchAction, currentSearch: string): string => {
  const searchParams = new URLSearchParams(action.searchParams)

  appendDateRangeSearchParams(searchParams, currentSearch)

  quickSearchNavigationSequence += 1

  searchParams.set("quickSearchAt", `${Date.now()}-${quickSearchNavigationSequence}`)

  return `?${searchParams.toString()}`
}
